import React from 'react';
import PropTypes from 'prop-types';

export default function EquippedShortlistComponent({
  children,
}) {
  return (
    <div className="equipped-shortlist">
      {children}
    </div>
  );
}

EquippedShortlistComponent.propTypes = {
  children: PropTypes.node,
};

EquippedShortlistComponent.defaultProps = {
  children: null,
};